import * as React from "react"

const UNINITIALIZED = {}

/**
 * A React.useRef() that is initialized with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useRefWithInit(sortColumns, columns)
 */
export function useRefWithInit<T>(init: () => T): React.RefObject<T>
export function useRefWithInit<T, U>(
  init: (arg: U) => T,
  initArg: U
): React.RefObject<T>
export function useRefWithInit(
  init: (arg?: unknown) => unknown,
  initArg?: unknown
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = React.useRef(UNINITIALIZED as any)

  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg)
  }

  return ref
}
